var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "stat_alerts_widget" } }, [
    _c("div", { staticClass: "pb-0", staticStyle: { position: "relative" } }, [
      _c("div", { staticClass: "mb-0 pb-0" }, [
        _c(
          "div",
          {
            staticClass: "container col-12 mb-0",
            staticStyle: { "margin-top": "0", width: "100% !important" },
          },
          [
            _c("div", { staticClass: "row panel pt-20 pl-15 pr-15" }, [
              _c("div", { staticClass: "steps tabs-wrapper mb-20" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "step col-lg-4",
                    class: { current: _vm.active_tab === 1 },
                    on: {
                      click: function ($event) {
                        _vm.active_tab = 1
                      },
                    },
                  },
                  [
                    _vm.active_groups.error
                      ? _c("span", { staticClass: "step-number" }, [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle",
                            class: {
                              blue: _vm.active_tab === 1,
                              white: _vm.active_tab === 2,
                            },
                            attrs: { "aria-hidden": "true" },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.active_groups.error && _vm.active_groups.loading
                      ? _c("span", { staticClass: "step-number" }, [
                          _c("i", {
                            staticClass: "fa fa-spinner fa-pulse",
                            class: {
                              blue: _vm.active_tab === 1,
                              white: _vm.active_tab === 2,
                            },
                            attrs: { "aria-hidden": "true" },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.active_groups.error && !_vm.active_groups.loading
                      ? _c(
                          "span",
                          {
                            staticClass: "step-number",
                            style: _vm.active_groups.font_style,
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.active_groups.count) +
                                "\n              "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(1),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "step col-lg-4",
                    class: { current: _vm.active_tab === 2 },
                    on: {
                      click: function ($event) {
                        _vm.active_tab = 2
                      },
                    },
                  },
                  [
                    _vm.finished_groups.error
                      ? _c("span", { staticClass: "step-number" }, [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle",
                            class: {
                              blue: _vm.active_tab === 2,
                              white: _vm.active_tab === 1,
                            },
                            attrs: { "aria-hidden": "true" },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.finished_groups.error && _vm.finished_groups.loading
                      ? _c("span", { staticClass: "step-number" }, [
                          _c("i", {
                            staticClass: "fa fa-spinner fa-pulse",
                            class: {
                              blue: _vm.active_tab === 2,
                              white: _vm.active_tab === 1,
                            },
                            attrs: { "aria-hidden": "true" },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.finished_groups.error && !_vm.finished_groups.loading
                      ? _c(
                          "span",
                          {
                            staticClass: "step-number",
                            style: _vm.finished_groups.font_style,
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.finished_groups.count) +
                                "\n              "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(2),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content-tab-widget",
                class: { hidden: _vm.active_tab === 2 },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [_c("top-counts-panel")],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "page-content page-content-widgets my-dashboard",
                        attrs: { id: "graphsBlock" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row", attrs: { id: "widgets" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xl-8 col-lg-12 col-xs-12 masonry-item",
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "DayStatsUsers" } },
                                  [_c("day-stats-users-diagram")],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xl-4 col-lg-6 col-xs-12 masonry-item",
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "HoursStatsUsers" } },
                                  [_c("hours-stats-users-diagram")],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xl-4 col-lg-6 col-xs-12 masonry-item",
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "UserStatsAll" } },
                                  [_c("user-stats-all-diagram")],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xl-4 col-lg-6 col-xs-12 masonry-item",
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "UserProgress" } },
                                  [_c("user-progress-diagram")],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xl-4 col-lg-6 col-xs-12 masonry-item",
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "UserPass" } },
                                  [_c("user-pass-diagram")],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content-tab-widget",
                class: { hidden: _vm.active_tab === 1 },
              },
              [
                _c("div", { staticClass: "row mb-0" }, [
                  _c("div", { staticClass: "col-lg-6 pl-0 pr-0" }, [
                    _c(
                      "div",
                      {
                        staticClass: "panel shadow-none mb-20",
                        attrs: { id: "DetailsOfReasonsByMonthsChart" },
                      },
                      [
                        _c("details-of-reasons-by-months-diagram", {
                          attrs: { active_tab: _vm.active_tab },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-6 pl-md-15 pr-0 pl-0 d-flex order-first order-md-last",
                    },
                    [
                      _c(
                        "div",
                        [_c("reasons-detalization-all-time-counts-panel")],
                        1
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row",
                class: { hidden: _vm.updated_at === "" },
                attrs: { id: "updated-at" },
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c("span", { staticClass: "pull-right" }, [
                    _vm._v(
                      "\n              Данные актуальны на " +
                        _vm._s(_vm.updated_at) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step disabled-step col-lg-4" }, [
      _c("span", { staticClass: "step-number" }, [
        _vm._v("\n                0\n              "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step-desc" }, [
        _c("span", { staticClass: "step-title" }, [
          _vm._v(
            "\n                  Запланированные учебные группы\n                "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-desc" }, [
      _c("span", { staticClass: "step-title" }, [
        _vm._v("\n                  Активные учебные группы\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-desc" }, [
      _c("span", { staticClass: "step-title" }, [
        _vm._v(
          "\n                  Завершенные учебные группы\n                "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }